export const parseImagesModule = (modules) => {
    const imageMap = {};

    Object.entries(modules).forEach(([key, value]) => {
        const parts = key.split("/");
        const fullName = parts[parts.length - 1];
        const fileName = fullName.split(".")[0];
        const ext = fullName.split(".")[1];
        if (!imageMap[fileName]) {
            imageMap[fileName] = { name: fileName };
        }
        imageMap[fileName][ext] = value;
    });
    return Object.values(imageMap);
};
